import React from 'react';

export const AdminPageShell = ({ children }) => (
  <div className="min-h-screen bg-slate-100 p-4 md:p-8">
    <div className="max-w-7xl mx-auto space-y-6">
      {children}
    </div>
  </div>
);

export const AdminPageHeader = ({ eyebrow, title, description, actions }) => (
  <div className="bg-white border border-slate-200 shadow-sm rounded-xl p-5 md:p-6">
    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
      <div>
        {eyebrow && <p className="text-sm font-bold text-sky-700 uppercase tracking-wide">{eyebrow}</p>}
        <h1 className="text-2xl md:text-3xl font-black text-slate-950 mt-1">{title}</h1>
        {description && <p className="text-slate-600 mt-2 max-w-3xl">{description}</p>}
      </div>
      {actions && <div className="flex flex-wrap gap-3">{actions}</div>}
    </div>
  </div>
);

export const StatCard = ({ label, value, tone = 'sky', detail }) => {
  const tones = {
    sky: 'border-sky-200 bg-sky-50 text-sky-800',
    emerald: 'border-emerald-200 bg-emerald-50 text-emerald-800',
    amber: 'border-amber-200 bg-amber-50 text-amber-800',
    rose: 'border-rose-200 bg-rose-50 text-rose-800',
    violet: 'border-violet-200 bg-violet-50 text-violet-800',
    slate: 'border-slate-200 bg-white text-slate-800'
  };

  return (
    <div className={`rounded-xl border shadow-sm p-5 ${tones[tone] || tones.sky}`}>
      <p className="text-sm font-semibold opacity-80">{label}</p>
      <p className="text-3xl font-black mt-2">{value}</p>
      {detail && <p className="text-sm mt-2 opacity-80">{detail}</p>}
    </div>
  );
};

export const AdminTabs = ({ tabs, activeTab, onChange }) => (
  <div className="bg-white border border-slate-200 rounded-xl shadow-sm p-2 overflow-x-auto">
    <div className="flex gap-2 min-w-max">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          onClick={() => onChange(tab.id)}
          className={`px-4 py-2.5 rounded-lg text-sm font-bold transition ${
            activeTab === tab.id
              ? 'bg-blue-950 text-white shadow'
              : 'text-slate-700 hover:bg-slate-100'
          }`}
        >
          {tab.label}
          {typeof tab.count === 'number' && (
            <span className={`ml-2 px-2 py-0.5 rounded-full text-xs ${activeTab === tab.id ? 'bg-white text-blue-950' : 'bg-slate-100 text-slate-600'}`}>
              {tab.count}
            </span>
          )}
        </button>
      ))}
    </div>
  </div>
);

export const NoticePanel = ({ title, children, tone = 'amber' }) => {
  const tones = {
    amber: 'bg-amber-50 border-amber-200 text-amber-900',
    sky: 'bg-sky-50 border-sky-200 text-sky-900',
    rose: 'bg-rose-50 border-rose-200 text-rose-900',
    emerald: 'bg-emerald-50 border-emerald-200 text-emerald-900'
  };

  return (
    <div className={`rounded-xl border p-4 ${tones[tone] || tones.amber}`}>
      <p className="font-black">{title}</p>
      <div className="text-sm mt-1 leading-relaxed">{children}</div>
    </div>
  );
};
